import React, { useEffect, useRef } from "react";

import PropTypes from "prop-types";

import { FileUpload } from "primereact/fileupload";

const Documentos = ({ HandleFileChange, arquivos = {} }) => {
  const fileUploadRefs = useRef({});

  // Função para atribuir refs
  const setFileUploadRef = (key) => (el) => {
    fileUploadRefs.current[key] = el;
  };

  // Restaurar arquivos quando o componente for montado
  useEffect(() => {
    Object.keys(arquivos).forEach(key => {
      if (arquivos[key] && fileUploadRefs.current[key]) {
        fileUploadRefs.current[key].setFiles([arquivos[key]]);
      }
    });
  }, [arquivos]);

  return (
    <div className="row g-3">
      <div className="col-sm-12 col-md-6">
        <label htmlFor="foto" className="form-label">
          FOTO*
        </label>
        <FileUpload
          ref={setFileUploadRef('foto')}
          name="foto"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "foto")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="pisEsocial" className="form-label">
          PIS | E-SOCIAL*
        </label>
        <FileUpload
          ref={setFileUploadRef('pisEsocial')}
          name="pisEsocial"
          customUpload
          auto={false}
          uploadHandler={null}
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "pisEsocial")}
        />
      </div>
      {/* Campo RG */}
      <div className="col-sm-12 col-md-6">
        <label htmlFor="rg" className="form-label">
          RG*
        </label>
        <FileUpload
          ref={setFileUploadRef('rg')}
          name="rg"
          customUpload
          auto={false}
          uploadHandler={null}
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "rg")}
        />
      </div>
      {/* Campo CPF */}
      <div className="col-sm-12 col-md-6">
        <label htmlFor="cpf" className="form-label">
          CPF*
        </label>
        <FileUpload
          ref={setFileUploadRef('cpf')}
          name="cpf"
          customUpload
          auto={false}
          uploadHandler={null}
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "cpf")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="endereco" className="form-label">
          COMPROVANTE DE ENDEREÇO*
        </label>
        <FileUpload
          ref={setFileUploadRef('endereco')}
          name="endereco"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "endereco")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="carteiraTrabalho" className="form-label">
          CARTEIRA DE TRABALHO*
        </label>
        <FileUpload
          ref={setFileUploadRef('carteiraTrabalho')}
          name="carteiraTrabalho"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "carteiraTrabalho")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="dadosBancarios" className="form-label">
          DADOS BANCÁRIOS*
        </label>
        <FileUpload
          ref={setFileUploadRef('dadosBancarios')}
          name="dadosBancarios"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "dadosBancarios")}
        />
      </div>

      <div className="col-sm-12 col-md-6">
        <label htmlFor="tituloEleitor" className="form-label">
          TÍTULO DE ELEITOR
        </label>
        <FileUpload
          ref={setFileUploadRef('tituloEleitor')}
          name="tituloEleitor"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "tituloEleitor")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="reservista" className="form-label">
          RESERVISTA
        </label>
        <FileUpload
          ref={setFileUploadRef('reservista')}
          name="reservista"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "reservista")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="cnh" className="form-label">
          CNH
        </label>
        <FileUpload
          ref={setFileUploadRef('cnh')}
          name="cnh"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "cnh")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="escolaridade" className="form-label">
          ESCOLARIDADE
        </label>
        <FileUpload
          ref={setFileUploadRef('escolaridade')}
          name="escolaridade"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "escolaridade")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="dependentes" className="form-label">
          DEPENDENTES
        </label>
        <FileUpload
          ref={setFileUploadRef('dependentes')}
          name="dependentes"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "dependentes")}
        />
      </div>
      <div className="col-sm-12 col-md-6">
        <label htmlFor="pensaoAlimenticia" className="form-label">
          PENSÃO ALIMENTÍCIA
        </label>
        <FileUpload
          ref={setFileUploadRef('pensaoAlimenticia')}
          name="pensaoAlimenticia"
          chooseLabel="Escolher"
          uploadLabel="Enviar"
          cancelLabel="Cancelar"
          customUpload
          auto={false}
          uploadHandler={null}
          multiple={false}
          accept="application/pdf,image/jpeg,image/png"
          onSelect={(e) => HandleFileChange(e, "pensaoAlimenticia")}
        />
      </div>
    </div>
  );
};

Documentos.propTypes = {
  HandleFileChange: PropTypes.func.isRequired
};

export default Documentos;
